var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.colleagues,"item-value":"id","item-text":"firstName","label":_vm.label,"clearable":"","dense":""},model:{value:(_vm.value_),callback:function ($$v) {_vm.value_=$$v},expression:"value_"}})}
var staticRenderFns = []

export { render, staticRenderFns }